import { featureCardData } from "../../../utils/data";

const UberFeatureCard = () => {
  return (
    <div className="uber-container">
      <div className="uber-features-wrap">
        <div>
          <h6 className="uber-features-title">
            <div className="primary-green">Key Features</div>
            of an Uber clone app
          </h6>
        </div>

        <div className="uber-feature-card-wrapper mt-5">
          {featureCardData.map((card) => {
            return (
              <div key={card.id} className="uber-feature-card">
                <h5>{card.cardTitle}</h5>
                <p>{card.cardContent}</p>
                <div className="feature-card-icon">
                  <img
                    src={require(`../../../image/uber/${card.icon}`)}
                    alt="Uber clone"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default UberFeatureCard;
